import { Flex } from "@similarweb/ui-components/foundations";

import { MatchingKeywords } from "./components/MatchingKeywords";
import { SuggestedKeyword } from "./components/SuggestedKeyword";
import { createKeyword } from "./createKeyword";
import { useKeywordListComposerContext } from "./KeywordListComposerContext";
import { trackPopupClick } from "./tracking";
import { useKeywordsVolumes } from "./useKeywordsVolumes";

export const KeywordListComposerCreatorQueryResult = () => {
    const { query, changeQuery, country, prependKeywords, checkIfKeywordExists } = useKeywordListComposerContext();
    const localKeyword = createKeyword({ term: query, isRecentlyAdded: true, isLoading: true });
    const { data: remoteKeyword } = useKeywordsVolumes({
        keywords: [localKeyword],
        country,
        enabled: localKeyword.term.length > 0,
        select: ({ Data }) => ({ ...localKeyword, volume: Data[localKeyword.term]?.AverageVolume, isLoading: false }),
    });
    const suggestedKeyword = remoteKeyword ?? localKeyword;
    const isExistingKeyword = checkIfKeywordExists(suggestedKeyword);

    const handleClick = () => {
        if (isExistingKeyword) {
            return;
        }
        prependKeywords([suggestedKeyword]);
        changeQuery("");
        trackPopupClick({ event: "Add Keyword", keyword: suggestedKeyword.term });
    };

    return (
        <Flex
            flexDirection="column"
            gap="16px"
            flexGrow="1"
        >
            <SuggestedKeyword
                keyword={suggestedKeyword}
                onClick={handleClick}
                isAlreadyExists={isExistingKeyword}
            />
            <MatchingKeywords />
        </Flex>
    );
};
